import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exclamation",
  "use": "exclamation-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"exclamation\"><path d=\"M11.865 14.354l-.656-4.656V6.546h2.176v3.152l-.624 4.656h-.896zm.432 3.552c-.459 0-.79-.106-.992-.32-.203-.213-.304-.485-.304-.816v-.32c0-.33.101-.602.304-.816.203-.213.533-.32.992-.32.448 0 .773.107.976.32.203.214.304.486.304.816v.32c0 .331-.101.603-.304.816-.203.214-.528.32-.976.32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol